import { render, staticRenderFns } from "./MenuNote.vue?vue&type=template&id=d90ebcc6&scoped=true&"
import script from "./MenuNote.vue?vue&type=script&lang=js&"
export * from "./MenuNote.vue?vue&type=script&lang=js&"
import style0 from "./MenuNote.vue?vue&type=style&index=0&id=d90ebcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90ebcc6",
  null
  
)

export default component.exports